import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../lib/auth-context';
import { FullPageSpinner } from '../RequireArea';
import { Sidebar } from './Sidebar';

/**
 * Oturum kapısı + kabuk.
 *
 * ⚠ `h-screen` (tam 100vh) ZORUNLU, `min-h-screen` DEĞİL. `min-h-screen` ile
 * `main`in `overflow-y-auto`su çalışmaz: içerik uzadıkça kap da uzar, kaydırma
 * belgeye taşar ve kenar çubuğu yukarı kayar. Uzun bir mizan veya denetim
 * kaydı listesinde bu hemen görünür.
 */
export function Layout() {
  const { user, verifying } = useAuth();

  if (!user) return verifying ? <FullPageSpinner /> : <Navigate to="/login" replace />;

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-6xl px-6 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
